import Cropper from "react-easy-crop";
import { useState } from "react";

import Icon from "../Icon/Icon";
import Button from "../Button/Button";
import { convertDataURLtoFile } from "../../utils";
import { hostname } from "../../services/configServices/config";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const AvatarCropper = ({
  value,
  onChange,
  onRemove,
  base64,
  isEditMode = true,
}) => {
  const [image, setImage] = useState("");
  const [fileName, setFileName] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);

  // Handle the change event when a file is selected
  const handleOnChange = (file) => {
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        onImageSelected(reader.result);
      };
    }
    document.getElementById(`upload-avatar`).value = "";
  };
  // Callback function when an image is selected
  const onImageSelected = (selectedImg) => {
    setImage(selectedImg);
  };

  // Callback when cropping is completed
  const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
    // Store the cropped area in pixels
    setCroppedArea(croppedAreaPixels);
  };

  // Callback function when cropping is done
  const onCropDone = (imgCroppedArea) => {
    // Create a canvas element to crop the image
    const canvasEle = document.createElement("canvas");
    canvasEle.width = imgCroppedArea.width;
    canvasEle.height = imgCroppedArea.height;

    const context = canvasEle.getContext("2d");

    // Load the selected image
    let imageObj1 = new Image();
    imageObj1.src = image;

    imageObj1.onload = () => {
      // Draw the cropped portion of the image onto the canvas
      context.drawImage(
        imageObj1,
        imgCroppedArea.x,
        imgCroppedArea.y,
        imgCroppedArea.width,
        imgCroppedArea.height,
        0,
        0,
        imgCroppedArea.width,
        imgCroppedArea.height
      );

      // Convert the canvas content to a data URL (JPEG format)
      const dataURL = canvasEle.toDataURL("image/jpeg");

      if (base64) {
        onChange(base64);
      } else {
        onChange(convertDataURLtoFile(dataURL, fileName));
      }
    };

    onCropReset();
  };

  const onCropReset = () => {
    setImage("");
    setFileName("");
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center mb-3">
        <div className="position-relative">
          {value && isEditMode && (
            <span
              className="btn btn-trigger rounded-circle btn-icon position-absolute bg-danger"
              style={{ left: 0, top: 0 }}
              onClick={onRemove}
            >
              <Icon name="trash" className="text-white" />
            </span>
          )}
          <label
            htmlFor="upload-avatar"
            className="p-1 rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: 150,
              height: 150,
              border: "4px solid #ddd",
            }}
          >
            {value ? (
              <img
                className="img-fluid rounded-circle"
                alt=""
                src={`${hostname}${value}`}
              />
            ) : (
              <Icon name="upload" className="fa-7x" />
            )}
            {isEditMode && (
              <input
                type="file"
                id="upload-avatar"
                className="d-none"
                accept="image/,.jpg,.jpeg,.png;capture=camera"
                onChange={(e) => {
                  const file = e.target.files[0];
                  handleOnChange(file);
                }}
              />
            )}
          </label>
        </div>
      </div>

      <Modal isOpen={image} className="modal-dialog-centered" size="md">
        <div className="px-3">
          <input
            type="range"
            min="1"
            max="5"
            step="0.05"
            className="form-control"
            value={zoom}
            onChange={(e) => setZoom(+e.target.value)}
          />
        </div>
        <ModalBody>
          <div style={{ height: 300 }}>
            <Cropper
              image={image}
              aspect={1 / 1}
              crop={crop}
              zoom={zoom}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
              style={{
                containerStyle: {
                  width: "100%",
                  height: "100%",
                },
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="mr-auto">
            <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-3">
              <li>
                <Button
                  color="primary"
                  size="lg"
                  type="submit"
                  onClick={() => onCropDone(croppedArea)}
                >
                  برش و ثبت
                </Button>
              </li>
              <li>
                <span
                  type="button"
                  onClick={onCropReset}
                  className="link link-light"
                >
                  انصراف
                </span>
              </li>
            </ul>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AvatarCropper;
